import React from 'react'

export const CurtainLoader = () => {
  return (
    <div className="section__loading">
      <div className="la-ball-pulse la-dark">
        <div></div>
        <div></div>
        <div></div>
      </div>
      <p className="loading__text" id="loadingText">
        Loading...
      </p>
    </div>
  )
}